require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reviews-manera-s-foam-helmet.json") })
        }
      }, "path---reviews-manera-s-foam-helmet");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reviews-manera-s-foam-helmet!./.cache/json/reviews-manera-s-foam-helmet.json
// module id = 688
// module chunks = 231608221292675